import { createFileRoute } from '@tanstack/react-router';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
  TabbedNavigationSubGroup,
} from '../../../../../../../../../components/router/router-tabbed-navigation';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/order/_order')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountSummaryList,
      subGroup: TabbedNavigationSubGroup.RegistrationAccountSummaryListOrders,
      label: 'Orders',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<
    TabbedNavigationGroup.RegistrationAccountSummaryList,
    TabbedNavigationSubGroup.RegistrationAccountSummaryListOrders
  >,
});
